/* eslint-disable */
import { emailRex } from '@/tools/basic-methods'
export const required = {
  required: true,
  message: "This field is required."
};

export function validatorRequired(message = 'This field is required.', trigger = 'blur') {
  return {
    required: true,
    message: message,
    trigger: trigger
  }
}

export function validatorEmailWithValue(value) {
  return {
    validator: (rule, valuee, callback) => {
      const regular = new RegExp(emailRex)
      if (!regular.test(value) && value && value.toString().length) {
        callback(new Error('Please enter a valid email address.'))
      } else {
        callback()
      }
    },
    trigger: "blur"
  }
}
export function validatorNumberWithValue(value) {
  return {
    validator: (rule, valuee, callback) => {
      if (!value) {
        callback()
        return
      }
      const regular = /^.{12}$/
      if (!regular.test(value)) {
        callback(new Error('Please enter a valid contact number.'))
      } else {
        callback()
      }
    },
    trigger: "blur"
  }
}

export function validatorRegular(regular, message, trigger) {
  const reg = typeof regular === 'string' ? new RegExp(regular) : regular
  return {
    validator: (rule, value, callback) => {
      if (value && !reg.test(value)) {
        callback(new Error(message))
      } else {
        callback()
      }
    },
    trigger: trigger
  }
}


export function validatorRegularAndRequired(regular, message) {
  const reg = typeof regular === 'string' ? new RegExp(regular) : regular
  return {
    validator: (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error(message))
      } else {
        callback()
      }
    },
  }
}

export const integer = {
  type: "integer",
  message: "The field must be an integer."
};


const validatorEmail = (rule, value, callback) => {
  const regular = new RegExp(emailRex)
  if (!regular.test(value) && value && value.toString().length) {
    callback(new Error('Please enter a valid email address.'))
  } else {
    callback()
  }
}

export const email = {
  validator: validatorEmail,
  // message: "Please enter a valid email address.",
  trigger: "blur"
};

const validatorPostCodeUSA = (rule, value, callback) => {
  const reg = /^\d{5}$/
  if (value && !reg.test(value)) {
    callback(new Error('Please enter valid 5-digit billing zip code.'))
  } else {
    callback()
  }
}

export const postCodeUSA = {
  required: [validatorRegular(/^\d{5}$/, 'Please enter valid 5-digit zip code.'), validatorRequired('Please enter valid 5-digit zip code.') ],
  notRequired: [validatorRegular(/^\d{5}$/, 'Please enter valid 5-digit zip code.', 'blur')]
}
export const postCodeCAN = {
  required: [validatorRegular(/^[0-9a-zA-Z]{6}$/, 'Please enter valid 6-digit zip code.'), validatorRequired('Please enter valid 6-digit zip code.') ],
  notRequired: [validatorRegular(/^[0-9a-zA-Z]{6}$/, 'Please enter valid 6-digit zip code.', 'blur')]
}
export const postCode = {
  required: [validatorRegular(/^[0-9a-zA-Z]{5,6}$/, 'Please enter a valid zip code.'), validatorRequired('Please enter a valid zip code.') ],
  notRequired: [validatorRegular(/^[0-9a-zA-Z]{5,6}$/, 'Please enter a valid zip code.', 'blur')]
}

const validatorEmailRequired = (rule, value, callback) => {
  const regular = new RegExp(emailRex)
  if (!regular.test(value)) {
    callback(new Error('Please enter a valid email address.'))
  } else {
    callback()
  }
}

export const emailRequired = {
  validator: validatorEmailRequired,
  // message: "Please enter a valid email address.",
  trigger: "blur"
}

const validatorPhone = (rule, value, callback) => {
  // value = (value || '').toString().replace(/[^\d]/g, '')
  const regular = /^[\d-]{12}$/
  if (!regular.test(value)) {
    callback(new Error('Please enter a valid contact number.'))
  } else {
    callback()
  }
}


export const phone = {
  validator: validatorPhone,
  trigger: "blur"
};


const PASSWORD_MIN_LENGTH = 4;
export const password = {
  min: PASSWORD_MIN_LENGTH,
  message: `Your password must contain a minimum of ${PASSWORD_MIN_LENGTH} characters.`,
  trigger: "blur"
};

const validatorPass = (rule, value, callback) => {
  // value = (value || '').toString().replace(/[^\d]/g, '')
  const passRegex = /^(?!.*[^A-Za-z0-9#?!@$%^&*+-]$)(?![a-z]*$)(?![A-Z]*$)(?![0-9]*$)(?![#?!@$%^&*-]*$).{8,16}$/
  if (!passRegex.test(value)) {
    callback(new Error('Please enter a valid password.'))
  } else {
    callback()
  }
}

export const validPassword = {
  validator: validatorPass,
  trigger: "blur"
}

export const creditCardExpirationDate = {
  pattern: /^(0[1-9]|1[0-2])\/([0-9]{2})$/,
  trigger: "blur",
  message: "Please enter a valid expiration date."
};
